import React, { Component } from "react";
import MUICard from "@mui/material/Card";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import MUIFileDownloadIcon from "@mui/icons-material/FileDownload";
import PropTypes from "prop-types";
import InlineTable from "../../Components/Custom/InlineTable";
import partsService from "../Security/ProductService/partsService";
import VendorService from "../Security/VendorService/vendorService";
// MDB Shim Imports
import Button from "../../Component/MDBShim/Button";
import MDBSpinner from "../../Component/MDBShim/MDBSpinner";

import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import LayerLegacy from "../../LayerLegacy";
import MainContext from "../../Context/MainContext/MainContext";

const fixedLightMaterialUITheme = createTheme({
  palette: { mode: "light" },
});

export default class ServicePartList extends LayerLegacy {
  constructor(props) {
    super(props);

    const columnMap = [
      {
        columnName: "ID",
        fieldName: "id",
        canEdit: false,
        type: "text",
        required: false,
        hidden: true,
        width: "40px",
      },
      {
        columnName: "Vendor",
        fieldName: "vendorId",
        canEdit: true,
        type: "dropdown",
        required: true,
        options: [],
        width: "200px",
      },
      {
        columnName: "Category",
        fieldName: "servicePartCatalogCategoryTermId",
        canEdit: true,
        type: "dropdown",
        required: false,
        options: [],
        width: "150px",
      },
      {
        columnName: "Model",
        fieldName: "model",
        canEdit: true,
        type: "autosuggest",
        required: true,
        options: [],
      },
      {
        columnName: "Description",
        fieldName: "description",
        canEdit: true,
        type: "text",
        required: false,
      },
      {
        columnName: "Item ID",
        fieldName: "itemId",
        canEdit: true,
        type: "text",
        required: true,
        width: "110px",
      },
      {
        columnName: "MSRP",
        fieldName: "msrp",
        canEdit: true,
        type: "float",
        required: true,
        width: "80px",
      },
      {
        columnName: "HCPC",
        fieldName: "hcpc",
        canEdit: true,
        type: "text",
        required: false,
        width: "80px",
      },
      {
        columnName: "HCPC (1)",
        fieldName: "hcpc1",
        canEdit: true,
        type: "text",
        required: false,
        width: "100px",
      },
      {
        columnName: "HCPC (2)",
        fieldName: "hcpc2",
        canEdit: true,
        type: "text",
        required: false,
        width: "100px",
      },
      {
        columnName: "Cost",
        fieldName: "cost",
        canEdit: true,
        type: "float",
        required: false,
        width: "80px",
      },
      {
        columnName: "Stock",
        fieldName: "stock",
        canEdit: true,
        type: "bool",
        required: false,
        defaultValue: false,
        width: "60px",
      },
      {
        columnName: "Tech",
        fieldName: "technicianSelectable",
        canEdit: true,
        type: "bool",
        required: false,
        defaultValue: true,
        width: "60px",
      },
      {
        columnName: "Bin",
        fieldName: "bin",
        canEdit: true,
        type: "text",
        required: false,
        width: "80px",
      },
      {
        columnName: "Inventory",
        fieldName: "inventory",
        canEdit: true,
        type: "int",
        required: false,
        width: "80px",
      },
      {
        columnName: "Deleted",
        fieldName: "deleted",
        canEdit: true,
        type: "bool",
        required: false,
        hidden: true,
        defaultValue: false,
        width: "60px",
      },
    ];
    const data = [];

    this.state = {
      data: data,
      alteredData: [],
      columnMap: columnMap,
      isLoaded: false,
      addModalOpen: false,
      vendorList: [],
      categoryTermList: [],
    };
  }
  static contextType = MainContext; // For legacy class components

  componentDidMount() {
    this.getParts();
    this.getVendors();
    this.getCategoryTerms();
  }

  getParts() {
    partsService
      .getAllParts()
      .then((data) => {
        this.setState(
          {
            // data: data,
            data:
              data && data.length > 0
                ? data.filter((x) => x.deleted !== true)
                : [],
            isLoaded: true,
          },
          () => this.updateColumnMap(),
        );
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoaded: true,
        });
      });
  }

  getVendors() {
    VendorService.getAllVendors()
      .then((res) => {
        this.setState({
          vendorList: res,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getVendorList() {
    let vendors = this.state.vendorList;

    let a = [];
    vendors.map((v) => {
      return a.push({
        label: v.name,
        value: v.id,
      });
    });
    return a;
  }
  getCategoryTerms() {
    const { termsIndexed } = this.context;
    let categoryTerms = [];
    Object.values(termsIndexed).forEach((term) => {
      if (term.type === "service_part_catalog_category") {
        categoryTerms.push(term);
      }
    });

    this.setState({
      categoryTermList: categoryTerms,
    });
  }
  getCategoryTermList() {
    let terms = this.state.categoryTermList;

    let a = [];
    terms.map((v) => {
      return a.push({
        label: v.name,
        value: v.id,
      });
    });
    return a;
  }

  updateColumnMap() {
    let vendors = this.getVendorList();
    let categories = this.getCategoryTermList();
    let models = Array.from(
      new Set(
        (this.state.data || [])
          .map((part) => (part.model || "").trim())
          .filter((model) => model.length > 0),
      ),
    ).sort((a, b) => a.localeCompare(b));

    let map = this.state.columnMap;
    map[1].options = vendors;
    map[2].options = categories;
    map[3].options = models;
    this.setState({
      columnMap: map,
    });
  }

  createNewPart(obj) {
    partsService
      .createPart(obj)
      .then((res) => {
        if (res) {
          NotistackEnqueueSnackbar("Part Created!", { variant: "success" });
          this.setState({
            isLoaded: false,
          });
          this.getParts();
        }
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "An error occurred creating the new entry: " + err,
          {
            variant: "error",
          },
        );
      });
  }

  editRows(rows) {
    partsService
      .batchEditParts(rows)
      .then((res) => {
        if (res) {
          NotistackEnqueueSnackbar("Part(s) saved", { variant: "success" });
          this.setState({
            isLoaded: false,
          });
          this.getParts();
        }
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "An error occurred updating the entries: " + err,
          {
            variant: "error",
          },
        );
      });
  }
  clientCSV(columnMap, rows, filename) {
    let result,
      ctr,
      keys = [],
      headers = [],
      columnDelimiter = ",",
      lineDelimiter = "\n",
      data;

    data = rows || null;
    if (data == null || !data.length) {
      return null;
    }

    columnMap.forEach((col) => {
      keys.push(col.fieldName);
      headers.push(col.columnName);
    });

    let replace = ["hcpc", "hcpc2", "itemId", "description"];
    let bool = ["stock"];

    result = "";
    result += headers.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function (item) {
      ctr = 0;
      keys.forEach(function (key) {
        if (ctr > 0) result += columnDelimiter;

        if (bool.indexOf(key) > -1) {
          result += !!item[key];
        } else if (replace.indexOf(key) > -1 && item[key] != null) {
          result += item[key].replace(/,/g, " ");
        } else {
          result += item[key];
        }
        ctr++;
      });
      result += lineDelimiter;
    });
    this.downloadBlob(result, filename);
  }

  //this actually prompts the download
  downloadBlob(csvData, filename) {
    let blob = new Blob([csvData], {
      type: "application/csv;charset=utf-8;",
    });

    if (window.navigator.msSaveBlob) {
      // FOR IE BROWSER
      navigator.msSaveBlob(blob, filename);
    } else {
      // FOR OTHER BROWSERS
      let link = document.createElement("a"),
        csvUrl = URL.createObjectURL(blob);

      link.href = csvUrl;
      link.style = "visibility:hidden";
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  renderContent() {
    return (
      <ThemeProvider theme={fixedLightMaterialUITheme}>
        <div className="mt-5">
          {this.state.isLoaded === false ? (
            <div style={{ textAlign: "center", verticalAlign: "middle" }}>
              <MDBSpinner />
            </div>
          ) : (
            <MUICard
              style={{
                backgroundColor: "rgb(88,129,193)",
                maxWidth: "90vw",
                marginLeft: "5vw",
              }}
            >
              <InlineTable
                tableHeader="Service Parts Catalog"
                paging={true}
                columnFieldMap={this.state.columnMap}
                allowRowSearch={true}
                batchSave={true}
                inlineEdit={true}
                rows={this.state.data}
                vendorList={this.state.vendorList}
                categoryTermList={this.state.categoryTermList}
                addItemMethod={this.createNewPart.bind(this)}
                editRowsMethod={this.editRows.bind(this)}
                modalHeader="Add Service Part"
              />
              <Button
                className={"downloadCsvButton"}
                floating
                size="sm"
                color={"primary"}
                data-tip={"Download CSV"}
                onClick={this.clientCSV.bind(
                  this,
                  this.state.columnMap,
                  this.state.data,
                  "Service-Parts-Catalog.csv",
                )}
              >
                <MUIFileDownloadIcon style={{ fontSize: "2em" }} />
              </Button>
            </MUICard>
          )}
        </div>
      </ThemeProvider>
    );
  }
}
